import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { ResetPasswordResponse, updatePassword } from "@/api";

export const useUpdatePassword = () => {
  return useMutation<
    ResetPasswordResponse,
    AxiosError<{ detail: string }>,
    { code: string; password: string }
  >(async ({ code, password }) => {
    const response = await updatePassword({ code, password });
    return response.data;
  });
};
